import { Stack } from 'expo-router';

import { colors } from '@/constants/theme';

/**
 * Season of Gifting stack. Headers are hidden — every screen renders its own
 * back affordance (mirrors the deals flow). Background pinned so pushes
 * don't flash white between light screens.
 */
export default function SeasonOfGiftingLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.background },
      }}
    />
  );
}
